import React from 'react';
import { useTranslation } from '@hooks/useTranslation';
import { getQuickDate } from '@utils/dateUtils';
import './QuickDateSelector.scss';

const QuickDateSelector = ({ onDateSelect, disabled = false }) => {
    const { t } = useTranslation();

    // Presets groupés par type - seulement heures et jours
    const hourPresets = [
        { key: '1h', hours: 1, label: '1', type: 'hours' },
        { key: '2h', hours: 2, label: '2', type: 'hours' },
        { key: '3h', hours: 3, label: '3', type: 'hours' },
        { key: '4h', hours: 4, label: '4', type: 'hours' },
        { key: '6h', hours: 6, label: '6', type: 'hours' },
        { key: '8h', hours: 8, label: '8', type: 'hours' },
        { key: '12h', hours: 12, label: '12', type: 'hours' }
    ];

    const dayPresets = [
        { key: '1d', days: 1, label: '1', type: 'days' },
        { key: '2d', days: 2, label: '2', type: 'days' },
        { key: '3d', days: 3, label: '3', type: 'days' },
        { key: '4d', days: 4, label: '4', type: 'days' },
        { key: '5d', days: 5, label: '5', type: 'days' },
        { key: '6d', days: 6, label: '6', type: 'days' },
        { key: '7d', days: 7, label: '7', type: 'days' },
    ];

    const handleQuickDateSelect = (preset) => {
        const quickDate = getQuickDate(preset.key);
        if (quickDate && onDateSelect) {
            onDateSelect(quickDate);
        }
    };

    return (
        <div className="quick-date-selection">
            <div className="quick-date-label">
                {t('borrowing.quickDate.title')}
            </div>

            <div className="quick-date-groups">
                {/* Groupe Heures */}
                <div className="quick-date-group hours-group">
                    <div className="group-title">
                        {t('borrowing.quickDate.hours', 'Heures')}
                    </div>
                    <div className="group-buttons">
                        {hourPresets.map(preset => (
                            <button
                                key={preset.key}
                                type="button"
                                onClick={() => handleQuickDateSelect(preset)}
                                className="btn-quick-date btn-hours"
                                disabled={disabled}
                                title={t('borrowing.quickDate.tooltip', 'Sélection rapide: {label}h', { label: preset.label })}
                            >
                                {preset.label}
                            </button>
                        ))}
                    </div>
                </div>

                {/* Groupe Jours */}
                <div className="quick-date-group days-group">
                    <div className="group-title">
                        {t('borrowing.quickDate.days', 'Jours')}
                    </div>
                    <div className="group-buttons">
                        {dayPresets.map(preset => (
                            <button
                                key={preset.key}
                                type="button"
                                onClick={() => handleQuickDateSelect(preset)}
                                className="btn-quick-date btn-days"
                                disabled={disabled}
                                title={t('borrowing.quickDate.tooltip', 'Sélection rapide: {label}j', { label: preset.label })}
                            >
                                {preset.label}
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default QuickDateSelector;
